import { TribunalCaseType } from '../../cases/types.js';
export var DKTribunalJobType;
(function (DKTribunalJobType) {
    DKTribunalJobType["CreateBetalingspaakrav"] = "CREATE_BETALINGSPAAKRAV";
    DKTribunalJobType["ResendBetalingspaakrav"] = "RESEND_BETALINGSPAAKRAV";
    DKTribunalJobType["Register1Paategning"] = "REGISTER_1_PAATEGNING";
    DKTribunalJobType["Register2Paategning"] = "REGISTER_2_PAATEGNING";
    DKTribunalJobType["ClosedObjection"] = "CLOSED_OBJECTION";
    DKTribunalJobType["CreateFogedrekvisition"] = "CREATE_FOGEDREKVISITION";
    DKTribunalJobType["RegisterInsolvency"] = "REGISTER_INSOLVENCY";
    DKTribunalJobType["RegisterPolicePresentation"] = "REGISTER_POLICE_PRESENTATION";
})(DKTribunalJobType || (DKTribunalJobType = {}));
export const tribunalDKJobReferenceCaseMap = {
    [DKTribunalJobType.RegisterInsolvency]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.DKFogedrekvisition,
    ],
    [DKTribunalJobType.CreateBetalingspaakrav]: [
        TribunalCaseType.DKBetalingspaakrav,
    ],
    [DKTribunalJobType.ClosedObjection]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.GLBetalingspaakrav,
    ],
    [DKTribunalJobType.Register1Paategning]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.GLBetalingspaakrav,
    ],
    [DKTribunalJobType.RegisterPolicePresentation]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.DKFogedrekvisition,
    ],
    [DKTribunalJobType.Register2Paategning]: [
        TribunalCaseType.DKBetalingspaakrav,
        TribunalCaseType.GLBetalingspaakrav,
    ],
    [DKTribunalJobType.ResendBetalingspaakrav]: [
        TribunalCaseType.DKBetalingspaakrav,
    ],
    [DKTribunalJobType.CreateFogedrekvisition]: [
        TribunalCaseType.DKFogedrekvisition,
    ],
};
//# sourceMappingURL=denmark.js.map